import React, { Component } from "react";
import {
MDBNavbar, MDBNavbarBrand,MDBAlert,MDBContainer, MDBNavbarNav, MDBIcon,MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBFormInline,
MDBDropdown, MDBDropdownToggle, MDBDropdownMenu,MDBSideNav, MDBDropdownItem
} from "mdbreact";
import { BrowserRouter as Router } from 'react-router-dom';
import Slider from '../../slider/slider'
import Header from '../../header/header'
import Card from '../products/products'
import Routes from "../../routes/routes";
class HomePage extends Component {
state = {
  isOpen: false
};

toggleCollapse = () => {
  this.setState({ isOpen: !this.state.isOpen });
}


render() {
  return (
      <div>
  
           
 
            <Slider/>
            <Header />
            <Card/>
            </div>
    );
  }
}

export default HomePage;